export enum SearchOperatingMode {
  Single = 1,
  Multiple = 2
}
